import React from 'react'
import Payslip from '../components/payslip'
import {loadPayslip} from '../store'
import PageviewGA from '../components/pageview-ga'

export default class extends React.Component {

    constructor(props) {
        super(props)
        loadPayslip( props.params.payslip_id)
    }

    render() {
        return (
            <div className="layout-row flex">
            	<PageviewGA path="/payslip/_id_"/>
            	<Payslip {...this.props} payslip={this.props.store.payslip}/>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/pages/view_payslip.js